import classNames from 'classnames';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import { Text } from 'hb-react/shared/components/formik/components/inputs';

interface Gift {
  is_fallback: boolean;
}

interface CustomFundProps {
  gift: Gift;
  name: string;
  biggerDisplay?: boolean;
  giftCustomFundError?: string;
}

interface CustomFundWrapperProps {
  $biggerDisplay?: boolean;
}

const CustomFund = ({
  gift,
  name,
  biggerDisplay,
  giftCustomFundError,
}: CustomFundProps) => {
  if (!gift.is_fallback) {
    return null;
  }

  return (
    <Box
      display="inline-block"
      textAlign="right"
      className={classNames({
        field_with_errors: giftCustomFundError,
      })}
    >
      <CustomFundWrapper $biggerDisplay={biggerDisplay}>
        <Box data-testid="custom-fund">
          <Box maxHeight="10px" pb={3} mb={8} ml={4}>
            <Text
              name={name}
              placeholder={__('Write in your designation *')}
              validate={{
                required: true,
              }}
              wrapperProps={{
                width: '250px',
              }}
            />
          </Box>
        </Box>
      </CustomFundWrapper>
      {giftCustomFundError && (
        <span className="error">{giftCustomFundError}</span>
      )}
    </Box>
  );
};

export default CustomFund;

const CustomFundWrapper = styled(Box)<CustomFundWrapperProps>`
  display: inline-block;

  ${({ $biggerDisplay }) =>
    $biggerDisplay &&
    `
    input {
      height: 61px;
      border-radius: 6px;
      font-size: 18px !important;
      padding-left: 34px !important;
      text-align: left;
    }
  `}
`;
